const CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes

type CacheEntry<T> = { data: T; timestamp: number };

const store = new Map<string, CacheEntry<unknown>>();

export function cacheGet<T>(key: string): T | null {
  const entry = store.get(key) as CacheEntry<T> | undefined;
  if (!entry) return null;
  if (Date.now() - entry.timestamp > CACHE_TTL_MS) {
    store.delete(key);
    return null;
  }
  return entry.data;
}

export function cacheSet<T>(key: string, data: T): void {
  store.set(key, { data, timestamp: Date.now() });
}

export function cacheClear(): void {
  store.clear();
}

// Expose in browser console: window.__clearGroupedSelectCache()
if (typeof window !== 'undefined') {
  (window as any).__clearGroupedSelectCache = cacheClear;
}